export default __webpack_public_path__ + "static/media/power-flow.4e353d3a.md";